import React from "react";
import { formatRand } from "./helpers";
import { ETA_PURPLE } from "./constants";

// The Eta-Purple payout card. Fixed sizes tuned to fit the card at the widths it
// actually gets in the app content area (narrower than the Figma canvas); the
// card sizes to its content.
const POSITIVE_GREEN = "#00FF00"; // Figma "#0f0"
const ERROR_RED = "#FF0000"; // Eta-Error token

// label + amount stack. `flexible` lets the earnings-row columns share width so
// each label wraps to more lines as the card narrows instead of colliding with
// the next column.
const Metric = ({ label, amount, amountColor = "#FFFFFF", flexible = false }) => (
  <div style={flexible ? { flex: "1 1 0", minWidth: 0 } : undefined}>
    <p className="font-light" style={{ fontSize: 13, color: "#FFFFFF", whiteSpace: "normal", overflowWrap: "break-word" }}>
      {label}
    </p>
    <p className="font-medium" style={{ fontSize: 17, color: amountColor, marginTop: 4 }}>
      {amount}
    </p>
  </div>
);

const PayoutCard = ({ totals = {}, breakdown = {} }) => {
  const etapath = breakdown.etapath?.earnings || 0;
  const uber = breakdown.uber?.earnings || 0;
  const bolt = breakdown.bolt?.earnings || 0;

  return (
    <div
      className="flex flex-col justify-between text-white"
      style={{
        backgroundColor: ETA_PURPLE,
        borderRadius: 16,
        padding: 20,
        boxShadow: "0 0 2px rgba(0,0,0,0.15)",
      }}>
      <div className="flex justify-between items-start" style={{ gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <p style={{ fontSize: 24, lineHeight: 1.2 }}>Total Payout</p>
          <p className="font-medium" style={{ fontSize: 34, lineHeight: 1.1, marginTop: 4 }}>
            {formatRand(totals.payout)}
          </p>
        </div>
        <div className="flex flex-col flex-shrink-0" style={{ gap: 8 }}>
          <Metric label="Bonuses" amount={formatRand(totals.bonuses)} amountColor={POSITIVE_GREEN} />
          <Metric label="Deductions" amount={formatRand(totals.deductions)} amountColor={ERROR_RED} />
        </div>
      </div>

      <div className="flex justify-between items-end" style={{ marginTop: 16, gap: 12 }}>
        <Metric flexible label="Etapath Earnings" amount={formatRand(etapath)} />
        <Metric flexible label="Uber Earnings" amount={formatRand(uber)} />
        <Metric flexible label="Bolt Earnings" amount={formatRand(bolt)} />
      </div>
    </div>
  );
};

export default PayoutCard;
